import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import { CenteredContainer } from '@nerdwallet/currency';

import { useQuery, gql } from '@nerdwallet/apollo';
import DepartmentBlogTile from './department-blog-tile';
import { logGqlError } from '~/client/lib/logger-utils';

const engBlogQuery = gql`
  query engBlogPosts {
    engineeringPosts(
      order: { field: DATE, sortDirection: DESC }
      pagination: { limit: 6 }
    ) {
      items {
        id
        link
        title
        featuredMedia {
          sourceUrl
        }
      }
    }
  }
`;

const CompanyEngBlog = () => {
  const { data, loading, error } = useQuery(engBlogQuery);
  if (loading || !data?.engineeringPosts?.items) return null;
  if (error) {
    logGqlError(error);
    return null;
  }
  const posts = data.engineeringPosts.items;
  const renderedPosts = _.map(posts, (post) => (
    <DepartmentBlogTile {...post} key={`item-${post.id}`} />
  ));

  return (
    <CenteredContainer
      className={classNames([
        'eng-blog__cont',
        classes('padding-vertical-0'),
        classes('padding-horizontal-3--wide'),
        classes('display-flex--wide'),
        classes('flex-direction-row--wide'),
        classes('flex-wrap--wide'),
        classes('margin-bottom-4'),
        classes('margin-bottom-5--wide'),
      ])}
    >
      {renderedPosts}
    </CenteredContainer>
  );
};

CompanyEngBlog.displayName = 'Company Engineering Blog';

export default CompanyEngBlog;
